<template>
  <div v-if="featuresList.length > 0" class="plans-filter-features">
    <div class="plans-filter-features__label">Особенности</div>
    <div class="plans-filter-features__dropdown">
      <div
        class="plans-filter-features__trigger"
        :class="{ active: isDropdownOpen || selectedFeatures.length > 0 }"
        @click="toggleDropdown"
      >
        <span class="plans-filter-features__text">
          <template v-if="selectedFeatures.length === 0">Все</template>
          <template v-else>{{ getFirstFeatureLabel() }}</template>
        </span>
        <div
          class="plans-filter-features__arrow"
          :class="{ open: isDropdownOpen }"
        >
          <img loading="lazy" src="@i/arrow.svg" width="12" height="5.5" />
        </div>
      </div>

      <div v-if="isDropdownOpen" class="plans-filter-features__dropdown-menu">
        <div class="plans-filter-features__dropdown-content">
          <div
            class="plans-filter-features__dropdown-item"
            :class="{ active: selectedFeatures.length === 0 }"
            @click="selectAll"
          >
            <span class="plans-filter-features__dropdown-text">Все</span>
          </div>

          <div
            v-for="feature in featuresList"
            :key="feature.key"
            class="plans-filter-features__dropdown-item"
            :class="{ active: selectedFeatures.includes(feature.key) }"
            @click="toggleFeature(feature.key)"
          >
            <span class="plans-filter-features__dropdown-text">{{
              feature.label
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlansFilterFeatures",

  inject: ["filterStore"],

  props: {
    flats: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isDropdownOpen: false,
      selectedFeatures: [],
      featuresList: [],
    };
  },

  computed: {
    featuresFilterActive() {
      return this.filterStore.state.filterFeats || [];
    },
  },

  watch: {
    flats: {
      handler(newFlats) {
        if (newFlats && newFlats.length > 0) {
          this.extractFeaturesFromData(newFlats);
        }
      },
      immediate: true,
    },

    featuresFilterActive: {
      handler(newValue) {
        this.selectedFeatures = [...newValue];
      },
      immediate: true,
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    extractFeaturesFromData(flats) {
      const featuresMap = new Map();

      const featureLabels = {
        view_from_window: "Виды из окон",
        with_balcony: "Наличие балкона",
        with_decoration: "Наличие отделки",
        with_decoration_whitebox: "Возможна предчистовая отделка",
        with_promotion: "Наличие акции",
        with_terrace: "Наличие террасы",
        with_large_bathroom: "Квартира с большой ванной комнатой",
        euroformat: "Квартира евроформата",
        master_bedroom: "Мастер-спальня",
        two_bathrooms_and_more: "2 ванные комнаты и более",
        view_botanical_garden: "Вид на Ботанический сад",
        view_ostankino_park: "Вид на парк Останкино",
        view_small_botanical_garden: "Вид на малый ботанический сад",
        multispace: "Мультипространство (без несущих стен)",
        vestibule_without_transit_ways: "Прихожая без транзитных путей",
        checkroom: "Гардеробная",
        panoramic_windows: "Панорамные окна",
        windows_on_2_sides: "Окна на 2 стороны света",
        view_intersection_park_areas: "Вид на пересечение парковых зон",
        increased_number_windows: "Увеличенное кол-во окон",
        mortgage_percent: "Особенные условия по ипотеки %",
        discount: "Скидка",
        design_with_furnishings: "Дизайнерская отделка с меблировкой",
      };

      flats.forEach((flat) => {
        if (flat.properties) {
          Object.keys(flat.properties).forEach((key) => {
            if (flat.properties[key] === true && featureLabels[key]) {
              featuresMap.set(key, featureLabels[key]);
            }
          });
        }
      });

      this.featuresList = Array.from(featuresMap, ([key, label]) => ({
        key,
        label,
      })).sort((a, b) => a.label.localeCompare(b.label));
    },

    getFirstFeatureLabel() {
      if (this.selectedFeatures.length === 0) return "";
      const firstFeatureKey = this.selectedFeatures[0];
      const feature = this.featuresList.find((f) => f.key === firstFeatureKey);
      return feature ? feature.label : firstFeatureKey;
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    selectAll() {
      this.selectedFeatures = [];
      this.filterStore.setFilterFeats([]);
      this.isDropdownOpen = false;
    },

    toggleFeature(featureKey) {
      if (this.selectedFeatures.includes(featureKey)) {
        this.selectedFeatures = this.selectedFeatures.filter(
          (key) => key !== featureKey
        );
      } else {
        this.selectedFeatures = [...this.selectedFeatures, featureKey];
      }
      this.filterStore.setFilterFeats(this.selectedFeatures);
      this.isDropdownOpen = false;
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
  },
};
</script>

<style scoped>
.plans-filter-features {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.plans-filter-features__label {
  font-weight: 500;
  font-size: 14px;
  color: #291f1f;
}

.plans-filter-features__dropdown {
  position: relative;
}

.plans-filter-features__trigger {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 305px;
  height: 56px;
  padding: 20px;
  border: 1px solid #e5e5e5;
  border-radius: 56px;
  background: #fff;
  color: inherit;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}

.plans-filter-features__trigger::after {
  content: "";
  position: absolute;
  top: 3px;
  right: 3px;
  bottom: 3px;
  left: 3px;
  border: 1px solid #fff;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.2s;
}

.plans-filter-features__trigger:hover {
  border-color: #ff0020;
}

.plans-filter-features__trigger.active::after {
  opacity: 0.2;
}

.plans-filter-features__text {
  font-weight: 500;
}

.plans-filter-features__arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}

.plans-filter-features__arrow.open {
  transform: rotate(180deg);
}

.plans-filter-features__dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  width: 100%;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin-top: 8px;
  overflow: hidden;
}

.plans-filter-features__dropdown-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 0;
}

.plans-filter-features__dropdown-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  color: #291f1f;
}

.plans-filter-features__dropdown-item:hover {
  background-color: #f8f8f8;
}

.plans-filter-features__dropdown-text {
  flex: 1;
  line-height: 1.4;
  font-size: 16px;
  font-weight: 500;
}
@media (max-width: 1280px) {
  .plans-filter-features__trigger {
    width: auto;
    max-width: 358px;
  }
}
@media (max-width: 992px) {
  .plans-filter-features {
    gap: 10px;
  }
}
@media (max-width: 768px) {
  .plans-filter-features__label {
    font-size: 12px;
  }
  .plans-filter-features__dropdown-text,
  .plans-filter-features__text {
    font-size: 12px;
  }
  .plans-filter-features__trigger {
    padding: 20px 15px;
  }
}
</style>
